import { createApp as g, nextTick as r } from "vue";
import h from "./AlertDialog.vue.js";
import { guid as i } from "../utils/basic.js";
let c, l;
const f = function(d, t, e) {
  c && l && (c.unmount(), l.remove()), l = document.createElement("div");
  const n = "div" + i();
  document.body.appendChild(l), e || (e = {}), (e == null ? void 0 : e.showOK) === void 0 && (e.showOK = !0);
  const u = e.callback, a = e.cancelcallback, v = {
    alertTitle: d,
    alertContent: t,
    divid: n,
    showCancel: !!(e != null && e.isConfirm),
    showOK: !!(e != null && e.showOK),
    yestext: e == null ? void 0 : e.yestext,
    notext: e == null ? void 0 : e.notext
  };
  c = g(h, v);
  const m = c.mount(l);
  m.confirmDailog = () => {
    u && r(() => {
      u();
    }), c && (c.unmount(), l.remove());
  }, m.cancelDailog = () => {
    a && r(() => {
      a();
    }), c && (c.unmount(), l.remove());
  }, m.closeDailog = () => {
    a && r(() => {
      a();
    }), c && (c.unmount(), l.remove());
  };
};
f.open = f;
f.close = () => {
  c && (c.unmount(), l.remove());
};
export {
  f as default
};
